module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#logout",
      toString: function () {
        return this.url;
      }
    }